import App from './App.svelte';

let app = null;
const targetEl = document.getElementById("online-widget");

if(targetEl){
    app = new App({
        target: targetEl,
    });
}

export default app;